import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { type PayloadAction } from "@reduxjs/toolkit";
import { guestOrderActions } from "./slice";
import {
  submitGuestOrder
} from "../../services/guestOrder/guestOrder.api";
import { withLoader } from "../loader/saga";
import { GuestOrderPayload } from "../../types/guestOrder";

// Worker Saga for POST
export function* submitGuestOrderSaga(
  action: PayloadAction<GuestOrderPayload>
): SagaIterator {
  try {
    const response = yield* withLoader(function* () {
      return yield call(submitGuestOrder, action.payload);
    });
    yield put(guestOrderActions.submitGuestOrderSuccess(response));
  } catch (error: any) {
    yield put(
      guestOrderActions.submitGuestOrderFailure(
        "Something went wrong.Please try again."
      )
    );
  }
}


function* guestOrderWatcherSaga() {
  yield takeLatest(
    guestOrderActions.submitGuestOrderStart.type,
    submitGuestOrderSaga
  );
}
export {
  guestOrderWatcherSaga
};
